<app
    [navigations]="navigations"
    [bannerComponent]="bannerComponent"
    [toolbarComponent]="toolbarComponent"
    [footerComponent]="footerComponent"
    [chatPanelComponent]="chatPanelComponent"
    [quickPanelComponent]="quickPanelComponent"
    [sidePanelComponent]="sidePanelComponent"
>
</app>
